import {
  GET_PROJECT_TYPES
} from '../mutation-types'

const state = {
  all: []
}

const mutations = {
  [GET_PROJECT_TYPES] (state, data) {
    state.all = data
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/projectTypes.js